import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _possibleConstructorReturn from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import _inherits from "/Users/eyalbarta/Projects/mb-portal-fe-quasar/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import "core-js/modules/es6.number.constructor.js";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import BaseModel from "./BaseModel";
import moment from 'moment';
var LoanRepayment = /*#__PURE__*/function (_BaseModel) {
  function LoanRepayment() {
    _classCallCheck(this, LoanRepayment);
    return _callSuper(this, LoanRepayment, arguments);
  }
  _inherits(LoanRepayment, _BaseModel);
  return _createClass(LoanRepayment, [{
    key: "isOverdue",
    value: function isOverdue() {
      return !this.isPaid() && moment(this.get('payment_date'), 'YYYY-MM-DD') < moment().startOf('day');
    }
  }, {
    key: "isPaid",
    value: function isPaid() {
      return this.get('is_paid') === 1;
    }
  }, {
    key: "amount",
    value: function amount() {
      return Number(this.get('amount'));
    }
  }, {
    key: "outstandingCapital",
    value: function outstandingCapital() {
      return this.get('capital_out');
    }
  }, {
    key: "paymentDate",
    value: function paymentDate() {
      return moment(this.get('payment_date'));
    }
  }, {
    key: "daysOverdue",
    value: function daysOverdue() {
      return moment().diff(this.paymentDate(), 'days');
    }
  }, {
    key: "discount",
    value: function discount() {
      return parseFloat(this.get('discount'));
    }
  }]);
}(BaseModel);
export default LoanRepayment;